import { colors } from "../../Styles";

export function Maximize({size = "20px", fillColor = colors.greyLightTertiary}) {
  return (
    <svg height={size} width={size} fill={fillColor} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 283.46 283.46">
      {/* <g transform="matrix(0.5042,-0.5042,0.5042,0.5042,66.874,80.6234)">
        <path d="M274.9,134.83L158.85,67.82L158.85,106.83L73.79,106.83L73.79,162.83L158.85,162.83L158.85,201.84L274.9,134.83Z"/>
      </g>
      <g transform="matrix(-0.5042,0.5042,-0.5042,-0.5042,216.586,202.837)">
        <path d="M274.9,134.83L158.85,67.82L158.85,106.83L73.79,106.83L73.79,162.83L158.85,162.83L158.85,201.84L274.9,134.83Z"/>
      </g>
      <g transform="matrix(-0.50208,-0.506312,0.506312,-0.50208,80.123,216.881)">
        <path d="M274.9,134.83L158.85,67.82L158.85,106.83L73.79,106.83L73.79,162.83L158.85,162.83L158.85,201.84L274.9,134.83Z"/>
      </g>
      <g transform="matrix(0.504947,0.503452,-0.503452,0.504947,202.606,66.9037)">
        <path d="M274.9,134.83L158.85,67.82L158.85,106.83L73.79,106.83L73.79,162.83L158.85,162.83L158.85,201.84L274.9,134.83Z"/>
      </g> */}
      <g transform="matrix(0.5042,-0.5042,0.5042,0.5042,66.874,80.6234)">
        <path d="M274.9,134.83L158.85,67.82L158.85,106.83L93.623,106.83L93.623,162.83L158.85,162.83L158.85,201.84L274.9,134.83Z"/>
      </g>
      <g transform="matrix(-0.5042,0.5042,-0.5042,-0.5042,216.586,202.837)">
        <path d="M274.9,134.83L158.85,67.82L158.85,106.83L93.623,106.83L93.623,162.83L158.85,162.83L158.85,201.84L274.9,134.83Z"/>
      </g>
      <g transform="matrix(-0.50208,-0.506312,0.506312,-0.50208,80.123,216.881)">
        <path d="M274.9,134.83L158.85,67.82L158.85,106.83L93.623,106.747L93.623,162.747L158.85,162.83L158.85,201.84L274.9,134.83Z"/>
      </g>
      <g transform="matrix(0.504947,0.503452,-0.503452,0.504947,202.606,66.9037)">
        <path d="M274.9,134.83L158.85,67.82L158.85,106.83L93.623,106.859L93.623,162.859L158.85,162.83L158.85,201.84L274.9,134.83Z"/>
      </g>
    </svg>
  );
}